import { render } from "./LayoutWithNav.vue?vue&type=template&id=b9491c5c"
import script from "./LayoutWithNav.vue?vue&type=script&lang=js"
export * from "./LayoutWithNav.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__